import { createElement, forwardRef } from 'react';
import classNames from 'classnames';

import s from './Title.sss';

type TitleProps = React.HTMLProps<HTMLTitleElement> & {
  type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  bold?: boolean;
};

export const Title: React.FC<TitleProps> = forwardRef<HTMLTitleElement, TitleProps>(
  ({
    children,
    type,
    bold = true,
    className,
  }, ref) => {
    const classes = classNames(
      s.title,
      className,
      { [s.bold]: bold },
    );

    return createElement(type, { className: classes, ref }, children);
  },
);

Title.displayName = 'Title';

export default Title;
